/*global
L
*/

import $ from "jquery";

const infrastructureMapBuilder = function (leafletHtmlID, leafletApiKey, markerOptions) {
  if ($("main").hasClass("print")) { return; }
  const container = $("#" + leafletHtmlID).closest(".card");

  const tileLayer = L.tileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png", {
    attribution: "&copy; <a href='https://www.openstreetmap.org/copyright'>OpenStreetMap</a> contributors"
  });

  container.on("wd:card-ready", () => {
    // http://developer.skobbler.com/getting-started/web#sec4
    // Options also get passed on to the base Leaflet map constructor
    const map = L.map(leafletHtmlID, {
      layers: [tileLayer],
      bicycleLanes: true,
      onewayArrows: true,
      pois: "all",
      primaryLanguage: "en",
      fallbackLanguage: "en",
      mapLabels: "transliterationOnly",
      retinaDisplay: "auto",
      zoomControl: true,
      zoomControlPosition: "top-left",
      center: [45, 0],
      zoom: 1,
      maxZoom: 13,
      minZoom: 2,
      scrollWheelZoom: false
    });

    // Null island is not a place.
    const maybeThrowBecauseOfNullCoords = function (coords) {
      const nullIsland = coords && coords[0] == 0 && coords[1] == 0 && coords.length == 2;

      if (nullIsland) {
        throw "NullCoordinatesInList";
      }
    };

    const markerClusterGroup = L.markerClusterGroup.layerSupport({
      iconCreateFunction: function(cluster) {
        const childCount = cluster.getChildCount();
        const children = cluster.getAllChildMarkers();
        const plantTypes = $.map(children, function (e) {
          return e.options.plant_type_class;
        });

        const uniqueSorted = $.uniqueSort(plantTypes);
        const allOnePlantType = uniqueSorted.length === 1;
        const firstPlantType = uniqueSorted[0];

        const plantTypeClass = allOnePlantType ? firstPlantType : "multiple-types";

        const c = " marker-cluster-large";

        return new L.DivIcon({ html: "<div><span>" + childCount + "</span></div>", className: "marker-cluster marker-cluster-" + plantTypeClass + c, iconSize: new L.Point(40, 40) });
      }
    });

    const titles = {
      "water-treatment": "Water treatment",
      "wastewater-treatment": "Wastewater treatment",
      "water-reuse": "Water reuse",
      "desalination": "Desalination",
      "organisation": "Utilities"
    };

    const plantTypeGroups = {};

    for (const key in titles) {
      if (titles.hasOwnProperty(key)) {
        plantTypeGroups[key] = [];
      }
    }

    const allMarkers = [];

    if (markerOptions.length > 0) {
      $.each(markerOptions, function (i, markerOptionObject) {
        const coordPair = markerOptionObject.coordinates;
        const popUp = markerOptionObject.pop_up;
        const tooltip = markerOptionObject.tooltip;

        maybeThrowBecauseOfNullCoords(coordPair);

        const icon = L.icon({
          iconUrl: markerOptionObject.icon_png,
          shadowUrl: markerOptionObject.shadow_png,
          iconSize: [32, 50],
          iconAnchor: [16, 50],
          popupAnchor: [0, -50]
        });
        const marker = L.marker(coordPair, {
          tooltip: {
            html: tooltip
          },
          icon: icon,
          plant_type_class: markerOptionObject.plant_type_class
        });

        const popUpOptions = {
          className: markerOptionObject.plant_type_class
        };

        if (plantTypeGroups[markerOptionObject.plant_type_class]) {
          marker.bindPopup(popUp, popUpOptions);
          allMarkers.push(marker);
          plantTypeGroups[markerOptionObject.plant_type_class].push(marker);
        }
      });

      const plantTypeLayers = {};
      let count;
      let title;
      let plantTypeGroup;

      for (const prop in plantTypeGroups) {
        if (plantTypeGroups.hasOwnProperty(prop)) {
          plantTypeGroup = plantTypeGroups[prop];
          count = plantTypeGroup.length;

          if (count > 0) {
            title = titles[prop] + " (" + count + ")";
            plantTypeLayers[title] = L.layerGroup(plantTypeGroups[prop]);
          }
        }
      }
      map.addLayer(markerClusterGroup);

      let layer, i = 0;
      for (const prop2 in plantTypeLayers) {
        if (plantTypeLayers.hasOwnProperty(prop2)) {
          layer = plantTypeLayers[prop2];

          markerClusterGroup.checkIn(layer);

          map.addLayer(plantTypeLayers[prop2]);
        }
      }

      const bounds = markerClusterGroup.getBounds();

      for (const prop3 in plantTypeLayers) {
        if (plantTypeLayers.hasOwnProperty(prop3)) {
          layer = plantTypeLayers[prop3];

          if (i++ > 0) {
            map.removeLayer(plantTypeLayers[prop3]);
          }
        }
      }

      if (allMarkers.length > 0) {
        window.setTimeout(function () {
          map.fitBounds(bounds, { padding: [50, 50] });
        }, 0);
      }

      L.control.layers(plantTypeLayers, {}, { collapsed: false }).addTo(map);

      container.on("leafresize", function (e) {
        map.invalidateSize();

        e.stopPropagation();
      });

      const mapNav = container.find(".leaflet-control-layers");

      const mapPane = container.find(".leaflet-map-pane");

      const rxTranslate = /translate(?:3d)?\(([^\)]+)\)/i;

      mapPane.append(mapNav);

      const setLegend = function () {
        // Place legend to the right
        const mapContainer = container.find(".leaflet-map-container")[0];
        mapNav[0].style.left = mapContainer.offsetWidth - mapNav[0].offsetWidth - 10 + "px";
      };

      const setTableHeightEqualToMapHeight = function () {
        // Setting height in CSS disables drag functionality on map
        const mapContainer = container.find(".leaflet-map-container");
        const plantsTable = container.find(".map-tables .plants");
        const utilitiesTable = container.find(".map-tables .utilities");
        const title = container.find(".map-tables h4");

        plantsTable.height(mapContainer.outerHeight() - title.outerHeight() + "px");
        utilitiesTable.height(mapContainer.outerHeight() - title.outerHeight() + "px");
      };

      const setTableTitle = function (title) {
        if ($(".map-tables h4").length) {
          $(".map-tables h4").text(title);
        } else {
          $(".map-tables").first().prepend(`<h4>${title}</h4>`);
        }
        setTableHeightEqualToMapHeight();
      };

      const observer = new MutationObserver(function(mutations) {
        if (mutations.some(m => m.attributeName === "style")) {
          // apply an inverse transform
          mapNav[0].style.transform = "translate(" + mapPane[0]
          .style
          .transform
          .match(rxTranslate)[1]
          .split(",")
          .slice(0, 2) /* extract only x and y; discard z */
          .map(n => parseInt(n, 10) * -1 + "px") /* invert values */ + ")";
          // keep mapNav in place during panning animation
          mapNav[0].style.transition = mapPane[0].style.transition;
        }
      });

      observer.observe(mapPane[0], {
        attributes: true
      });

      (function () {
        const mapTablesContainer = container.find(".map-tables");
        const defaultLayerName = Object.keys(plantTypeLayers)[0];
        const buttonsContainer = mapTablesContainer.find(".buttons");

        setLegend();
        // See https://developer.mozilla.org/en-US/docs/Web/Events/resize
        (function() {
          let running = false;
          const throttle = function(type, name) {
            const func = function() {
              if (running) { return; }
              running = true;
              requestAnimationFrame(function() {
                window.dispatchEvent(new CustomEvent(name));
                running = false;
              });
            };
            window.addEventListener(type, func);
          };

          throttle("resize", "optimisedResize");
        })();
        window.addEventListener("optimisedResize", function () {
          setLegend();
        });

        const toggleTables = function (layerName) {
          const type = layerName.split(" (")[0];
          const operaterColumnIndex = 5;
          const populationColumnIndex = 7;
          const technologyColumnIndex = 8;
          const feedwaterColumnIndex = 9;
          let tableContainer, table;

          buttonsContainer.find(".btn").each(function () {
            const button = $(this);

            if (button.data().buttonType === type) {
              button.show();
            } else {
              button.hide();
            }
          });

          let title;
          if (type === "Utilities") {
            mapTablesContainer.find(".plants").hide();
            mapTablesContainer.find(".utilities").show();
            title = "Largest utilities, by population served";
            setTableTitle(title);
          } else {
            mapTablesContainer.find(".utilities").hide();

            tableContainer = mapTablesContainer.find(".plants");

            tableContainer.show();

            table = tableContainer.find("table");

            if (type === "Desalination") {
              table.DataTable().column(feedwaterColumnIndex).visible(true);
              table.DataTable().column(populationColumnIndex).visible(false);
              title = "Largest desalination plants, by capacity";
            } else {
              table.DataTable().column(feedwaterColumnIndex).visible(false);
              table.DataTable().column(populationColumnIndex).visible(true);
            }

            if (type === "Wastewater treatment") {
              table.DataTable().column(operaterColumnIndex).visible(false);
              title = "Largest wastewater treatment plants, by capacity";
            } else {
              table.DataTable().column(operaterColumnIndex).visible(true);
            }

            if (type === "Water treatment") {
              table.DataTable().column(technologyColumnIndex).visible(false);
              container.find(".map-tables .col-heading_6 span").text("Population served");
              title = "Largest water treatment plants, by capacity";
            } else {
              table.DataTable().column(technologyColumnIndex).visible(true);
              container.find(".map-tables .col-heading_6 span").text("Population equivalent");
            }

            setTableTitle(title);

            const doIt = function () {
              // table.DataTable().column(1).visible(false);
              table.find("tr").each(function () {
                const tr = $(this);
                tr.find("th:first-child, td:first-child").hide();

                if (tr.find("th").length > 0) return;

                const typeTd = tr.find("td.col-heading_0");

                if (typeTd.text().trim() !== type) {
                  tr.hide();
                } else {
                  tr.show();
                }
              });
            };
            table.on("draw.dt", doIt);
            doIt();
          }
        };

        toggleTables(defaultLayerName);
        // hide utilities
        // identify default layer in map
        // hide all other rows in plants table
        // show only that redirect button
        map.on("baselayerchange", function (e) {
          toggleTables(e.name);
        });
      })();
    }
  });
};

export default infrastructureMapBuilder;
